export default __webpack_public_path__ + "static/media/industrial_14.6f222843.png";